const updateFrequencies = {
  id: "updateFrequencies",
  label: "Update Frequencies",
  endpoint: "update_frequencies",
  columnConfig: [
    {
      field: "name",
      headerName: "Update Frequency",
      width: 250,
      description: "Update Frequency",
      editable: true,
    },
  ],
  hiddenColumns: ["id"],
  chipConfig: {},
  tagConfig: {},
};

export default updateFrequencies;
